import React, { useEffect, useState } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "../assets/css/style.css";
import "../assets/css/bootstrap.min.css";
import backArrow from "../assets/img/back_arrow.svg";
import Header from "./Header";
import { useLocation, useNavigate } from "react-router-dom";
import { post } from "../api/services";
import Spinner from "./Spinner";
import { whitelistText } from "../utility/whitelistText";

const CustomerSearch1 = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { filteredCustomer, customerName, selectedFromDate, selectedToDate } =
    location.state || {};

  const [searchName, setSearchName] = useState(customerName || "");
  const [fromDate, setFromDate] = useState(
    selectedFromDate ? selectedFromDate.split("-").reverse().join("-") : ""
  );
  const [toDate, setToDate] = useState(
    selectedToDate ? selectedToDate.split("-").reverse().join("-") : ""
  );

  //console.log("Filtered Customer:", filteredCustomer?.data?.CustomerData);

  const [customerOffers, setCustomerOffers] = useState(
    filteredCustomer?.data?.CustomerData
  );

  //const [customerOffers, setCustomerOffers] = useState(CustomerDataTest);

  const [selectedOffer, setSelectedOffer] = useState(null); // State to track the selected checkbox

  const [loading, setLoading] = useState(false); // State to handle loading
  const [error, setError] = useState(null); // State to handle errors

  useEffect(() => {
    const fetchCustomerOffers = async () => {
      if (!searchName || !fromDate || !toDate) {
        return; // Do not call API if any field is empty
      }
      setLoading(true); // Start loading
      setError(null); // Reset error state
      try {
        const response = await post("/getCustomerOffers", {
          customername: searchName,
          fromDate: fromDate?.split("-").reverse().join("-"),
          toDate: toDate?.split("-").reverse().join("-"),
        });

        setCustomerOffers(response?.data?.CustomerData); // Set the API response to state
      } catch (err) {
        setError("Failed to fetch customer offers. Please try again.");
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1500); // Simulate a delay
      }
    };
    fetchCustomerOffers();
  }, [toDate]);

  const handleRegenerateClick = () => {
    if (selectedOffer === null) {
      alert("Please select an offer to Regenerate Offer.");
      return;
    }
    // Navigate to the RM Form page with the selected offer number
    navigate("/rmFormPage", {
      state: { task: "customerSearch1", offerNo: selectedOffer },
    });
  };

  const handleAddNewProductsClick = () => {
    if (selectedOffer === null) {
      alert("Please select an offer to add new products.");
      return;
    }

    const selectedOfferData = customerOffers?.filter(
      (item) => item.offerno == selectedOffer
    )[0]?.product_details;

    // Navigate to the RM Form page with the selected offer number
    navigate("/summarypage", {
      state: {
        task: "customerSearch1",
        offerNo: selectedOffer,
        productList: selectedOfferData,
      },
    });
  };

  const handleCheckboxChange = (offerNo) => {
    setSelectedOffer((prevSelectedOffer) =>
      prevSelectedOffer === offerNo ? null : offerNo
    );

    // Update the customerOffers state to reflect the checkbox selection
    const updatedOffers = customerOffers.map((offer) => ({
      ...offer,
      select: offer.offerno === offerNo ? !offer.select : false,
    }));
    setCustomerOffers(updatedOffers);
  };

  return (
    <section className="multistep_sec customer_search_list">
      <Header />
      <div className="container-fluid" style={{ marginTop: "3%" }}>
        <div className="back_arrow">
          <p>
            <a href="#">
              <img className="back" src={backArrow} alt="Back" /> Back
            </a>
          </p>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="menu_link_section">
              <div className="content_box">
                <div className="form-card">
                  <div className="row justify-content-center">
                    <div className="col-md-9">
                      <form>
                        <div className="cus_form">
                          <div className="custom_filed custom_basic w-100">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label
                                    htmlFor="customerName"
                                    className="basic"
                                  >
                                    Search Customer
                                  </label>
                                  <input
                                    type="search"
                                    className="form-control"
                                    placeholder="Enter Customer Name"
                                    id="customerName"
                                    autoComplete="off"
                                    value={searchName}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (val.length > 100) {
                                        alert(
                                          "Customer Name must be less than or equal to 100 characters"
                                        );
                                        return;
                                      }
                                      if (!whitelistText(val)) {
                                        alert(
                                          "Customer Name contains invalid characters"
                                        );
                                        return;
                                      }
                                      setSearchName(val);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-md-3 col-6">
                                <div className="form-group">
                                  <label htmlFor="fromDate" className="basic">
                                    Form Date
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    placeholder="From"
                                    id="fromDate"
                                    value={fromDate}
                                    onChange={(e) =>
                                      setFromDate(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-3 col-6">
                                <div className="form-group">
                                  <label htmlFor="toDate" className="basic">
                                    To Date
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    placeholder="To"
                                    id="toDate"
                                    value={toDate}
                                    disabled={!fromDate}
                                    min={fromDate}
                                    max={
                                      fromDate
                                        ? (() => {
                                            const from = new Date(fromDate);
                                            const maxDate = new Date(from);
                                            maxDate.setMonth(
                                              maxDate.getMonth() + 3
                                            );
                                            // Adjust for months with fewer days
                                            if (
                                              maxDate.getDate() !==
                                              from.getDate()
                                            ) {
                                              maxDate.setDate(0);
                                            }
                                            return maxDate
                                              .toISOString()
                                              .split("T")[0];
                                          })()
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setToDate(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                      const dateValue = e.target.value;
                                      if (!dateValue || !fromDate) return;

                                      const fromDateObj = new Date(fromDate);
                                      const toDateObj = new Date(dateValue);
                                      const threeMonthsLater = new Date(
                                        fromDateObj
                                      );
                                      threeMonthsLater.setMonth(
                                        threeMonthsLater.getMonth() + 3
                                      );

                                      if (toDateObj > threeMonthsLater) {
                                        alert(
                                          "To Date cannot be more than 3 months after From Date."
                                        );
                                        setToDate("");
                                        e.target.value = "";
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="col-md-12">
                      <div
                        className="summary_box web_view_search p-0"
                        style={{ background: "#ffffff" }}
                      >
                        <div className="recommended_box">
                          <h4>Search Result</h4>
                          <div className="recommended_table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Offer No.</th>
                                  <th>Products</th>
                                  <th>Offer Generated on</th>
                                  <th>Client Name</th>
                                  <th>Select Client</th>
                                </tr>
                              </thead>
                              {!loading &&
                              customerOffers &&
                              customerOffers.length > 0 ? (
                                customerOffers?.map((item, index) => (
                                  <tbody key={index}>
                                    <tr>
                                      <td className="tableCustomerData">
                                        {item?.offerno}
                                      </td>
                                      <td>
                                        {item?.product_details
                                          ?.filter(
                                            (product) =>
                                              product?.selects === "true"
                                          )
                                          ?.map((product, index) => (
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                              }}
                                              className="product_name tableCustomerData"
                                              key={index}
                                            >
                                              <div className="text">
                                                <p>
                                                  <b>{product?.product_name}</b>
                                                </p>
                                              </div>
                                            </div>
                                          ))}
                                      </td>
                                      <td className="tableCustomerData">
                                        {item?.offer_date}
                                      </td>
                                      <td className="tableCustomerData">
                                        {item?.customer_name}
                                      </td>
                                      <td>
                                        <div className="custom-checkbox tableCustomerData">
                                          <input
                                            id={`checkbox-${item.offerno}`}
                                            name={`checkbox-${item.offerno}`}
                                            type="checkbox"
                                            checked={item?.select || false}
                                            onChange={() =>
                                              handleCheckboxChange(item.offerno)
                                            }
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                ))
                              ) : (
                                <tbody>
                                  <tr>
                                    <td colSpan="5" className="text-center">
                                      {loading
                                        ? `Searching...`
                                        : `No data available`}
                                    </td>
                                  </tr>
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="summary_box mobile">
                        <h4>Search Result</h4>
                        <div className="recommended_mobile">
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              {!loading &&
                              customerOffers &&
                              customerOffers.length > 0 ? (
                                customerOffers.map((item, index) => (
                                  <div className="recommended_card" key={index}>
                                    <div className="top_rec">
                                      <div className="product_list_scrollable">
                                        {item?.product_details
                                          ?.filter(
                                            (product) =>
                                              product?.selects === "true"
                                          )
                                          ?.map((product, index) => (
                                            <div
                                              className="text_list"
                                              key={index}
                                            >
                                              <div className="text">
                                                <p>{product?.product_name}</p>
                                              </div>
                                            </div>
                                          ))}
                                      </div>
                                      <div className="check_list">
                                        <div className="custom-checkbox">
                                          <input
                                            id={`checkbox-${item.offerno}`}
                                            name={`checkbox-${item.offerno}`}
                                            type="checkbox"
                                            checked={item?.select || false}
                                            onChange={() =>
                                              handleCheckboxChange(item.offerno)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="rec_content">
                                      <div className="reco_list">
                                        <p>Offer No.</p>
                                        <p className="bold">{item?.offerno}</p>
                                      </div>
                                      <div className="reco_list">
                                        <p>Client Name</p>
                                        <p className="bold">
                                          {item?.customer_name}
                                        </p>
                                      </div>
                                      <div className="reco_list">
                                        <p>Offer Generated on</p>
                                        <p className="bold">
                                          {item?.offer_date}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <tbody>
                                  <tr>
                                    <td colSpan="5" className="text-center">
                                      {loading
                                        ? `Searching...`
                                        : `No data available`}
                                    </td>
                                  </tr>
                                </tbody>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mt-0 text-center">
                        <div className="next_btn">
                          <button
                            name="next"
                            className="custom mt-0"
                            onClick={handleRegenerateClick}
                          >
                            Regenerate Same Offer
                          </button>
                          <h5>OR</h5>
                          <p className="link_add">
                            <a onClick={handleAddNewProductsClick}>
                              Add New Products as per the Requirement
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && <Spinner />}
    </section>
  );
};

export default CustomerSearch1;
